import { gql, useQuery } from '@apollo/client'

import {
  PersonalInfoFragment,
  PersonalInfoFragmentDoc,
  PersonalInfoQuery,
} from '@/clients/utoniq-core/schema'
import { User } from '@/core'
import { makeViewModel } from '@/core/architecture'

type UserWithPersonalInfo = User & PersonalInfoFragment

type State = {
  user: UserWithPersonalInfo | null
  isPersonalInfoComplete: boolean
}

type Action = Record<string, never>

export const useMembershipViewModel = makeViewModel<State, Action>(() => {
  const { data } = useQuery<PersonalInfoQuery>(QUERY)
  const user = data?.user as UserWithPersonalInfo | null

  const isPersonalInfoComplete = (
    user: UserWithPersonalInfo | null
  ): boolean => {
    if (!user) return false
    return !!(
      user.fullName &&
      user.phoneNumber &&
      user.isPhoneNumberVerified &&
      user.birthday &&
      user.gender &&
      user.address?.postalCode &&
      user.address?.prefecture &&
      user.address?.city &&
      user.address?.line1
    )
  }

  return {
    state: {
      user,
      isPersonalInfoComplete: isPersonalInfoComplete(user),
    },
    actions: {},
  }
})

const QUERY = gql`
  query PersonalInfo {
    user {
      ...PersonalInfo
    }
  }
  ${PersonalInfoFragmentDoc}
`
